<div class="spinnder-div" *ngIf="isLoading" data-cy="ar-card-payment-receipt-loading">
    <div class="error-message" data-cy="ar-card-payment-receipt-error">
      {{errorMessage}}
    </div>
    <div class="spinner-holder" data-cy="ar-card-payment-receipt-spinner-holder">
      <mat-spinner data-cy="ar-card-payment-receipt-spinner"></mat-spinner>
    </div>
  </div>

<img id="printButton" alt="Print" title="Print" (click)="print()" src="assets/Images/imaging/top-menu/icons8-printer.svg" 
style="float:right; margin-left: 20px; margin-right: 20px; cursor:pointer; width:50px;position:relative;top:-50px;" data-cy="ar-card-payment-receipt-print-btn">
<div class="container" data-cy="ar-card-payment-receipt">
    <div class="center" data-cy="ar-card-payment-receipt-header">
        <h2 data-cy="ar-card-payment-receipt-practice-name">{{paymentReceipt.PracticeName}}</h2>
        <div data-cy="ar-card-payment-receipt-practice-address">{{paymentReceipt.PracticeAddress}}</div>
        <div data-cy="ar-card-payment-receipt-practice-address2">{{paymentReceipt.PracticeAddress2}}</div>
        <div data-cy="ar-card-payment-receipt-practice-phone">{{paymentReceipt.PracticePhone}}</div>
    </div>
    <div class="row" style="margin-top:20px" data-cy="ar-card-payment-receipt-details-title">
        <h2 data-cy="ar-card-payment-receipt-details-heading">Payment Details</h2>
    </div>
    <div class="row" data-cy="ar-card-payment-receipt-details">
        <div class="col-12" data-cy="ar-card-payment-receipt-details-container">
            <div class="row" data-cy="ar-card-payment-receipt-patient-row">
                <div class="col-4" data-cy="ar-card-payment-receipt-patient-label">Patient:</div>
                <div class="col-8" data-cy="ar-card-payment-receipt-patient-value">{{paymentReceipt.PatientName}}</div>
            </div>
            <div class="row" data-cy="ar-card-payment-receipt-cardholder-row">
                <div class="col-4" data-cy="ar-card-payment-receipt-cardholder-label">Card Holder Name:</div>
                <div class="col-8" data-cy="ar-card-payment-receipt-cardholder-value">{{paymentReceipt.CardHolderName}}</div>
            </div>
            <div class="row" data-cy="ar-card-payment-receipt-date-row">
                <div class="col-4" data-cy="ar-card-payment-receipt-date-label">Payment Date:</div>
                <div class="col-8" data-cy="ar-card-payment-receipt-date-value">{{ moment(paymentReceipt.PaymentDate).format('LLL') }}</div>
            </div>
            <div class="row" data-cy="ar-card-payment-receipt-reference-row">
                <div class="col-4" data-cy="ar-card-payment-receipt-reference-label">Payment Reference:</div>
                <div class="col-8" data-cy="ar-card-payment-receipt-reference-value">{{paymentReceipt.PaymentReference}}</div>
            </div>
            <div class="row" data-cy="ar-card-payment-receipt-account-row">
                <div class="col-4" data-cy="ar-card-payment-receipt-account-label">Payment Account:</div>
                <div class="col-8" data-cy="ar-card-payment-receipt-account-value">{{paymentReceipt.PaymentAccount}}</div>
            </div>
            <div class="row" data-cy="ar-card-payment-receipt-description-row">
                <div class="col-4" data-cy="ar-card-payment-receipt-description-label">Transaction Description:</div>
                <div class="col-8" data-cy="ar-card-payment-receipt-description-value">{{paymentReceipt.PaymentDescription}}</div>
            </div>
            <div class="row" data-cy="ar-card-payment-receipt-total-row">
                <div class="col-4" data-cy="ar-card-payment-receipt-total-label">Total:</div>
                <div class="col-8" data-cy="ar-card-payment-receipt-total-value">{{paymentReceipt.PaymentAmount | currency}}</div>
            </div>
        </div>
    </div>
    <div class="col-12" style="margin-top:80px" data-cy="ar-card-payment-receipt-divider">
        <hr />
    </div>
    <div class="center" *ngIf="showPaymentAgreement" data-cy="ar-card-payment-receipt-agreement">
        <div data-cy="ar-card-payment-receipt-agreement-line1">I AGREE TO PAY THE ABOVE TOTAL AMOUNT</div>
        <div data-cy="ar-card-payment-receipt-agreement-line2">ACCORDING TO THE CARD ISSUER</div>
        <div data-cy="ar-card-payment-receipt-agreement-line3">AGREEMENT MERCHANT IF CREDIT VOUCHER</div>
        <div data-cy="ar-card-payment-receipt-agreement-line4"></div>
        <div data-cy="ar-card-payment-receipt-agreement-line5">THANK YOU</div>
    </div>

</div>